import { useTranslation } from 'react-i18next'
import { useMemo } from 'react'
import Tooltip from '@mui/material/Tooltip'
import Badge from '@mui/material/Badge'
import Box from '@mui/material/Box'

import { getOption, useParticipantStatusOptions } from '../../../utils'
import { ParticipantStatus } from '../../../types'
import { StatusTag, StatusTagProps } from '../../root/components/StatusTag'

export default function ParticipantStatusTag({
  status,
  absolute,
  position = 'top',
  size = 'medium',
}: {
  status?: ParticipantStatus | null
} & Partial<StatusTagProps>) {
  const { t } = useTranslation('events')
  const participantStatusOptions = useParticipantStatusOptions(t)

  const option = useMemo(
    () => getOption(participantStatusOptions, undefined, status),
    [participantStatusOptions, status]
  )

  let title: string | undefined
  let badgeContent: React.ReactNode = 0
  switch (status) {
    case ParticipantStatus.Cancelled:
      title = t('Le remboursement de votre inscription sera effectué sous quelques jours.')
      badgeContent = <strong>i</strong>
      break
    default:
      title = undefined
      badgeContent = 0
  }

  return option?.label ? (
    <Box
      width="fit-content"
      position="absolute"
      sx={{
        position: absolute ? 'absolute' : undefined,
        [position]: absolute ? '1rem' : undefined,
        right: absolute ? '1rem' : undefined,
      }}
    >
      <Tooltip title={title}>
        <Badge badgeContent={badgeContent} color="info">
          <StatusTag size={size} absolute={false} color={option.color} position={position}>
            {option.label}
          </StatusTag>
        </Badge>
      </Tooltip>
    </Box>
  ) : null
}
